import React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input } from 'antd';
import intl from 'react-intl-universal';
import './Identity.scss';
import {store} from 'Store/store.index';

export default class Identity extends React.Component {
  static storageKey () {
    return 'IDENTITY-FORM-DATA';
  }

  constructor(props) {
    super(props);

    this.state = {
      firstName: '', 
      lastName: '', 
      title: '', 
      organizationName: '', 
      organizationalUnit: '', 
      emailAddress: ''
    };
    this.props.onChange(this.state);
  }
  
  setFormData = (key, {target: {value}}) => {
    const obj = {};
    obj[key] = value;
    this.setState(obj, () => {
      this.storageFormData();
      this.props.onChange(this.state);
    });
  }

  // 保存表单操作记录
  storageFormData = () => {
    localStorage.setItem(Identity.storageKey(), JSON.stringify(this.state));
  }

  resetStateFromStorage = () => {
    let state = localStorage.getItem(Identity.storageKey());
    if (state) {
      state = JSON.parse(state);
      this.setState(state);
    }
  }

  UNSAFE_componentWillMount() { 
    this.resetStateFromStorage();
  }

  render() {
    const layout_LayoutGrid = {
      labelCol: { span: 9 },
      wrapperCol: { span: 14 , offset: 1 },
    };
    const input_style = {
      width: '240px'
    }
    const {
      firstName, 
      lastName,
      title,
      organizationName,
      organizationalUnit,
      emailAddress
    } = this.state;

    // const fullname = store.userStore.userInfo ? store.userStore.userInfo.fullname : '';
    const fullname = store.userNewStore.userData ? store.userNewStore.userData.nickname : '';
    const Title = intl.formatMessage({ id: 'Preferences.Content.Identity.Title' });
    const LoginName = intl.formatMessage({ id: 'Preferences.Content.Identity.LoginName' });
    const FirstName = intl.formatMessage({ id: 'Preferences.Content.Identity.FirstName' });
    const LastName = intl.formatMessage({ id: 'Preferences.Content.Identity.LastName' });
    const SubTitle = intl.formatMessage({ id: 'Preferences.Content.Identity.SubTitle' });
    const OrganizationName = intl.formatMessage({ id: 'Preferences.Content.Identity.OrganizationName' });
    const OrganizationalUnit = intl.formatMessage({ id: 'Preferences.Content.Identity.OrganizationalUnit' });
    const EmailAddress = intl.formatMessage({ id: 'Preferences.Content.Identity.EmailAddress' });

    return (
      <div className="identity-panel">
        <div className="title">{Title}</div>
        <div className="LayoutGrid">
          <Form {...layout_LayoutGrid} name="Identity" size='small'>
            <Form.Item label={LoginName} name="LoginName">
              <Input defaultValue={fullname} style={input_style} readOnly onChange={(value)=>{this.setFormData('loginName',value)}} />
            </Form.Item>
            <Form.Item label={FirstName} name="FirstName">
              <Input defaultValue={firstName} style={input_style} onChange={(value)=>{this.setFormData('firstName',value)}} />
            </Form.Item>
            <Form.Item label={LastName} name="LastName">
              <Input defaultValue={lastName} style={input_style} onChange={(value)=>{this.setFormData('lastName',value)}} />
            </Form.Item>
            <Form.Item label={SubTitle} name="Title">
              <Input defaultValue={title} style={input_style} onChange={(value)=>{this.setFormData('title',value)}} />
            </Form.Item>
            <Form.Item label={OrganizationName} name="OrganizationName">
              <Input defaultValue={organizationName} style={input_style} onChange={(value)=>{this.setFormData('organizationName',value)}} />
            </Form.Item>
            <Form.Item label={OrganizationalUnit} name="OrganizationalUnit">
              <Input defaultValue={organizationalUnit} style={input_style} onChange={(value)=>{this.setFormData('organizationalUnit',value)}} />
            </Form.Item>
            <Form.Item label={EmailAddress} name="EmailAddress">
              <Input defaultValue={emailAddress} style={input_style} onChange={(value)=>{this.setFormData('emailAddress',value)}} />
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}
